import { LISCase } from "pwapi";

export const workProcessState = (w: LISCase["work_processes"][0]) => {
  const taskType = w.tasks?.find((t) => !t.completed_at)?.type;
  return taskType ?? "completed";
};

export const workProcessSort = (
  w1: LISCase["work_processes"][0],
  w2: LISCase["work_processes"][0]
) => {
  if (!w1.id || !w2.id) return 0;

  if (w1.order?.id && w2.order?.id) return w1.order.id - w2.order.id;
  if (!w1.order?.id && !w2.order?.id) return w1.id - w2.id;
  if (w1.order?.id && !w2.order?.id) return 1;
  if (!w1.order?.id && w2.order?.id) return -1;
  return 0;
};
